import { useParams } from 'next/navigation'
import React from 'react'
import { AddressPickerDecorator } from './address-picker-decorator/AddressPickerDecorator'
import { useDeliveryAddress } from '@/delivery-address/client'
import { AddressPicker } from '@/tools/ui/components/header/ui/address-prompt/address-picker/AddressPicker'

interface Props {
  color?: string
  isIntersecting: boolean
  showLocationScrollDrawer: boolean
  centered?: boolean
  hideArrow?: boolean
  forceAddressPicker?: boolean
}

export const AddressPrompt: React.FC<Props> = ({
  color,
  isIntersecting,
  showLocationScrollDrawer,
  hideArrow,
  centered,
  forceAddressPicker,
}) => {
  const { city } = useParams()
  const isBrandHeader = color === 'brand'
  const { deliveryAddress, doesDeliveryAddressMatchLocation } = useDeliveryAddress()

  const shouldShowAddressInput =
    (isIntersecting && isBrandHeader) || !isBrandHeader || forceAddressPicker

  const addressToShow = doesDeliveryAddressMatchLocation() ? deliveryAddress?.text : undefined

  if (!shouldShowAddressInput) {
    return null
  }

  return (
    <AddressPickerDecorator
      centered={centered}
      city={city}
      deliveryAddressText={addressToShow}
      hideArrow={hideArrow}
      isBrandHeader={isBrandHeader}
    >
      <AddressPicker
        addressText={addressToShow}
        centered={centered}
        color={color}
        showLocationScrollDrawer={showLocationScrollDrawer}
      />
    </AddressPickerDecorator>
  )
}
